import url from "./url";
import { GET, POST, exportFile, GetGeo,FORM,POSTBody } from "./apiFn";

export default {
    // 用户的增删改查
    /**

@method login
@param {password，username} 参数名:{}
@description
*/
    login: params => GET(url.login, params), // 登陆
    GetGeo, //高德获取地址
    /**
     @method logout
     @param {} 参数名:{} 
     @description
    */
    logout: params => POST(url.logout, params), // 登出

    /**
     @method showUser
     @param {} 参数名:{}
     @description
    */
    showUser: params => GET(url.showUser, params), // 用户展示

    /**
     @method addUser
     @param {} 参数名:{}
     @description
    */
    addUser: params => POSTBody(url.addUser, params), // 添加用户

    /**
     @method updateUser
     @param {} 参数名:{}
     @description
    */
    updateUser: params => POST(url.updateUser, params), // 修改用户信息

    /**
     @method delUser
     @param {} 参数名:{}
     @description
    */
    delUser: params => POST(url.delUser, params), // 修改用户信息


    /**
     @method updatePassword
     @param {} 参数名:{}
     @description
    */
    updatePassword: params => POST(url.updatePassword, params), // 修改密码


    //组织
    /**
     @method upDateOrganization
     @param {} 参数名:{}
     @description
    */
    upDateOrganization: params => POST(url.upDateOrganization, params), // 修改组织信息

    /**
     @method delOrganization
     @param {} 参数名:{}
     @description
    */
    delOrganization: params => POST(url.delOrganization, params), // 删除组织信息

    /**
     @method getOrganization
     @param {} 参数名:{}
     @description
    */
    getOrganization: params => GET(url.getOrganization, params), // 查找单个组织信息

    /**
     @method addOrganization
     @param {} 参数名:{}
     @description
    */
    addOrganization: params => POST(url.addOrganization, params), // 添加组织

    /**
     @method getOTree
     @param {} 参数名:{}
     @description
    */
    getOTree: params => GET(url.getOTree, params), // 组织信息展示

    //设备
    /**
     @method updateVehicle
     @param {} 参数名:{}
     @description
    */
    updateVehicle: params => POST(url.updateVehicle, params), // 修改车辆信息

    /**
     @method delVehicle
     @param {} 参数名:{}
     @description
    */
    delVehicle: params => POST(url.delVehicle, params), // 删除设备信息

    /**
     @method getVehiclesByOId
     @param {} 参数名:{}
     @description
    */
    getVehiclesByOId: params => GET(url.getVehiclesByOId, params), // 根据组织获取设备信息

    /**
     @method addVehicle
     @param {} 参数名:{}
     @description
    */
    addVehicle: params => POST(url.addVehicle, params), // 添加设备信息

    /**
     @method removeVehicle
     @param {} 参数名:{}
     @description
    */
    removeVehicle: params => POST(url.removeVehicle, params), // 车辆转移


    /**
     @method getVehicleDetali
     @param {} 参数名:{}
     @description
    */
    getVehicleDetali: params => GET(url.getVehicleDetali, params), // 获取设备详情

    /**
     @method getMonitor
     @param {} 参数名:{}
     @description
    */
    getMonitor: params => GET(url.getMonitor, params), // 获取设备详情

    //批量导出
    /**
     @method doWriteExcelUser
     @param {} 参数名:{}
     @description
    */
    doWriteExcelUser: params => exportFile(url.doWriteExcelUser, params), // 用户批量导出

    /**
     @method writeExcelVehicle
     @param {} 参数名:{}
     @description
    */
    writeExcelVehicle: params => exportFile(url.writeExcelVehicle, params), // 设备批量导入

    /**
     @method getVehicleByL
     @param {} 参数名:{}
     @description
    */
    getVehicleByL: params => GET(url.getVehicleByL, params), // 设备批量导入

    //监控中心

    /**
      @method getVehicleState
      @param {} 参数名:{}
      @description
    */
    getVehicleState: params => GET(url.getVehicleState, params), // 设备批量导入

    /**
    @method getPosInfo
    @param {} 参数名:{}
    @description
    */
    getPosInfo: params => GET(url.getPosInfo, params), // 获取气泡数据（最后位置相关数据）

    /**
    @method getMonitorInfo
    @param {} 参数名:{}
    @description
    */
    getMonitorInfo: params => GET(url.getMonitorInfo, params), // 电池监控信息

    /**
    @method getElectricCurve
    @param {} 参数名:{}
    @description
    */
    getElectricCurve: params => GET(url.getElectricCurve, params), // 电池监控信息

    /**
    @method getAlarms
    @param {} 参数名:{}
    @description
    */
    getAlarms: params => GET(url.getAlarms, params), // 报警加载

    /**
    @method getHomePageInfo
    @param {} 参数名:{}
    @description
    */
    getHomePageInfo: params => GET(url.getHomePageInfo, params), // 首页统计



    /**
@method getSevenDayOnOfflineInfo
@param {} 参数名:{}
@description
*/
    getSevenDayOnOfflineInfo: params => GET(url.getSevenDayOnOfflineInfo, params), //统计7日在线离线休眠数目


    /**
@method getCurveInfo
@param {} 参数名:{}
@description
*/
    getCurveInfo: params => GET(url.getCurveInfo, params), //统计充放电曲线


    /**
@method getCalculatAlarmInfo
@param {} 参数名:{}
@description
*/
    getCalculatAlarmInfo: params => GET(url.getCalculatAlarmInfo, params), //故障数目统计



    /**
@method getComonInfo
@param {} 参数名:{}
@description
*/
    getComonInfo: params => GET(url.getComonInfo, params), //一般状态统计

    /**
@method getBaseAndTodayInfo
@param {} 参数名:{}
@description
*/
    getBaseAndTodayInfo: params => GET(url.getBaseAndTodayInfo, params), //基本信息与当日统计


    /**
@methods getMockPileWarnPileInfo
@param {}
@description
*/
    getMockPileWarnPileInfo: params => GET(url.getMockPileWarnPileInfo, params), //设备全数据


    /**
@methods commandDown
@param {}
@description
*/
    commandDown: params => POST(url.commandDown, params), //控制下发

    /**
@methods getOnOfflineReport
@param {}
@description
*/
    getOnOfflineReport: params => GET(url.getOnOfflineReport, params), //离线报表


    /**
@methods getMockPileWarnPileInfoBetter
@param {}
@description
*/
    getMockPileWarnPileInfoBetter: params => GET(url.getMockPileWarnPileInfoBetter, params), //电池详情-GPRS-BETTER


    /**
@methods getRealtimeAlarmReport
@param {}
@description
*/
    getRealtimeAlarmReport: params => GET(url.getRealtimeAlarmReport, params), //实时报表

    /**
@methods getCommandReport
@param {}
@description
*/
    getCommandReport: params => GET(url.getCommandReport, params), //实时报表

    /**
@methods getBmsTrack
@param {}
@description
*/
    getBmsTrack: params => GET(url.getBmsTrack, params), //电池记录

    /**
@methods getPosTrack
@param {}
@description
*/
    getPosTrack: params => GET(url.getPosTrack, params), //轨迹查询

    /**
@methods getOnOfflineInfo
@param {}
@description
*/
getOnOfflineInfo: params => GET(url.getOnOfflineInfo, params), //获取当前在线、离线、休眠数目


//设备续费
/**
@methods queryMyState
@param {}
@description 更新用户信息
*/
queryMyState: params => GET(url.queryMyState, params),

/**
@methods queryVehicleExpire
@param {
    activationTmeEnd: string, //结束激活时间
    activationTmeStart: string, //开始激活时间
    expireTime: number, //过期时间
    offlineTime: number, //离线时间
    organizationId: number, //组织ID
    pageNumber: number, //分页数量
    pageSize: number, //分页大小
    vehicleId: number, //车辆ID
    vehicleState: string //车辆状态 (静止，行驶，异常登出，休眠，全部不传参)
}
@description 获取续费列表
*/
queryVehicleExpire: params => POST(url.queryVehicleExpire, params),

/**
@methods queryVehicleFreeLog
@param {
    endTime: string, //结束时间
    startTime: string, //开始时间
    vid: number //车辆ID
}
@description 查询车辆续费记录
*/
queryVehicleFreeLog: params => POST(url.queryVehicleFreeLog, params),

/**
@methods giveUserRecharge
@param {
    userId: number, //接受方用户ID
    chargeNum: number //币数
}
@description 对下级用户做货币划拨
*/
giveUserRecharge: params => POST(url.giveUserRecharge, params),


/**
@methods queryRechargeLog
@param {
    endTime: string, //结束时间
    startTime: string, //开始时间
    userId: number //用户ID(可不填表示查所有)
}
@description 查询车辆续费记录
*/
queryRechargeLog: params => POST(url.queryRechargeLog, params),

/**
@methods getChargeAndGive
@param {
    chargeCount: number, //充值数量
    moneyGive: number, //赠送币数
    price: number, //价格
    remark: string, //赠送备注
    type: number, //操作类型(1：充值 2：赠送)
    userId: number, //客户代码ID
    years: number, //年限
}
@description 充值or赠送（总账号）
*/
getChargeAndGive: params => POST(url.getChargeAndGive, params),

/**
@methods getQueryChargeLog
@param {
    endTime: string, //结束时间
    startTime: string, //开始时间
    userId: number //查询客户的ID(可不填，表示查询所有客户)
}
@description 查询充值记录（总账号）
*/
getQueryChargeLog: params => GET(url.getQueryChargeLog, params),

/**
@methods vehicleRecharge
@param {
    addMonth: number //充值月份
    gvids: string //组织，车辆(多个车组，车辆 车组和车辆用,隔开，多组用;隔开)
}
@description 用户对车辆续费
*/
vehicleRecharge: params => GET(url.vehicleRecharge, params),

/**
@methods batchRecharge
@param {
    addMonth: number //续费时间，单位月
    terminalNo: string //设备号[设备号与设备号之间以英文逗号分隔]
}
@description 批量续费
*/
batchRecharge: params => POST(url.batchRecharge, params),


/**
@methods doDownVehFile
@param {
    sessionId: string
}
@description 获取车辆续费操作文档
*/
doDownVehFile: params => exportFile(url.doDownVehFile, params),

/**
@methods getAllRegoinInfo

@description 获取地域信息
*/
getAllRegoinInfo: params => GET(url.getAllRegoinInfo, params),

/**
@methods getBmsTrackDetail

@description 报表中心查看详情数据
*/
getBmsTrackDetail: params => GET(url.getBmsTrackDetail, params),

/**
@methods getVehicleImportTemp

@description 查询校验的结果-批量添加设备
*/
getVehicleImportTemp: params => GET(url.getVehicleImportTemp, params),

/**
@methods importVehicleExcel

@description 导入车辆excel表-批量添加设备
*/
importVehicleExcel: params => FORM(url.importVehicleExcel, params),

/**
@methods clearImportTemp

@description 清除数据库缓存信息-批量添加设备
*/
clearImportTemp: params => GET(url.clearImportTemp, params),

/**
@methods updateErrorInfo

@description 修改并校验错误结果(返回修改信息)-批量添加设备
*/
updateErrorInfo: params => POSTBody(url.updateErrorInfo, params),

/**
@methods writePosExcel

@description 导出位置信息报表
*/
writePosExcel: params => exportFile(url.writePosExcel, params),

/**
@methods writeBmsSourceExcel

@description 导出bms电池原始信息
*/
writeBmsSourceExcel: params => exportFile(url.writeBmsSourceExcel, params),

/**
@methods batchAddVehicle

@description 导出bms电池原始信息
*/
batchAddVehicle: params => POST(url.batchAddVehicle, params),

/**
@methods pageUpgradeFiles

@description 分页获取远程升级文件列表
*/
pageUpgradeFiles: params => GET(url.pageUpgradeFiles, params),

/**
@methods addUpgradeFiles

@description 新增远程升级文件
*/
addUpgradeFiles: params => FORM(url.addUpgradeFiles, params),

/**
@methods deleteUpgradeFiles

@description 删除远程升级文件
*/
deleteUpgradeFiles: params => GET(url.deleteUpgradeFiles, params),

/**
@methods getUpgradeFiles

@description 获取指令下发远程升级所需要的文件
*/
getUpgradeFiles: params => GET(url.getUpgradeFiles, params),

/**
@methods pageRemoteUpgradeLog

@description 分页获取远程升级日志
*/
pageRemoteUpgradeLog: params => GET(url.pageRemoteUpgradeLog, params),

/**
@methods pageBindDriverInfo

@description 获取绑定司机信息
*/
pageBindDriverInfo: params => GET(url.pageBindDriverInfo, params),

/**
@methods instructionIssuanceRemoteUpgrade

@description 达锂-远程升级
*/
instructionIssuanceRemoteUpgrade: params => POSTBody(url.instructionIssuanceRemoteUpgrade, params),

/**
@methods instructionIssuanceReadRegister

@description 达锂-读寄存器
*/
instructionIssuanceReadRegister: params => POSTBody(url.instructionIssuanceReadRegister, params),

/**
@methods instructionIssuanceWriteRegister

@description 达锂-写单个寄存器
*/
instructionIssuanceWriteRegister: params => POSTBody(url.instructionIssuanceWriteRegister, params),

/**
@methods instructionIssuanceBatchWriteRegister

@description 达锂-写多个单个寄存器
*/
instructionIssuanceBatchWriteRegister: params => POSTBody(url.instructionIssuanceBatchWriteRegister, params),

/**
@methods queryProtectiveBoardData

@description 读寄存器-查询保护板数据
*/
queryProtectiveBoardData: params => GET(url.queryProtectiveBoardData, params),

/**
@methods queryHistoricalFaultInformation

@description 读寄存器-查询设备历史故障信息
*/
queryHistoricalFaultInformation: params => GET(url.queryHistoricalFaultInformation, params),

/**
@methods getDeviceRealBMSData

@description 获取达锂设备实时BMS数据（保护板数据）
*/
getDeviceRealBMSData: params => GET(url.getDeviceRealBMSData, params),

/**
@methods deviceUnbind

@description 设备解绑
*/
deviceUnbind: params => POSTBody(url.deviceUnbind, params),

/**
@methods pageUserRoleLog

@description 分页查询权限变更记录
*/
pageUserRoleLog: params => GET(url.pageUserRoleLog, params),

/**
@methods getBinddeviceInfo

@description 获取绑定设备信息
*/
getBinddeviceInfo: params => GET(url.getBinddeviceInfo, params),

/**
@methods pageAlarmReport
@description 分页历史报警明细
*/
pageAlarmReport: params => GET(url.pageAlarmReport, params),

/**
@methods exportAlarmReport
@description 导出历史报警明细
*/
exportAlarmReport: params => exportFile(url.exportAlarmReport, params),

/**
@methods exportDeviceRealBMSData
@description 导出达锂设备实时BMS数据
*/
exportDeviceRealBMSData: params => exportFile(url.exportDeviceRealBMSData, params),

/**
@methods listPathInfo
@description 获取用户下的所有重点区域信息
*/
listPathInfo: params => GET(url.listPathInfo, params),

/**
@methods deletePathInfo
@description 删除重点区域
*/
deletePathInfo: params => GET(url.deletePathInfo, params),

/**
@methods updateAreaEnable
@description 变更区域启用状态
*/
updateAreaEnable: params => POSTBody(url.updateAreaEnable, params),

/**
@methods addPathInfo
@description 新增重点区域信息
*/
addPathInfo: params => POSTBody(url.addPathInfo, params),

/**
@methods updatePathInfo
@description 修改重点区域信息
*/
updatePathInfo: params => POSTBody(url.updatePathInfo, params),

/**
@methods getPathInfo
@description 根据围栏id获取重点区域信息
*/
getPathInfo: params => GET(url.getPathInfo, params),

/**
@methods getVehicleBindInfo
@description 根据pathId获取与该重点区域绑定的所有车组车辆相关数据（视图展示）
*/
getVehicleBindInfo: params => GET(url.getVehicleBindInfo, params),

/**
@methods bindVehicleToPath
@description 车组车辆绑定到重点区域
*/
bindVehicleToPath: params => POSTBody(url.bindVehicleToPath, params),


};
